import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../style/contact.css';
import { FcGoogle } from 'react-icons/fc';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';

const Contact = ({ showPopup, handlePopupToggle }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [email, setEmail] = useState('');

  const login = useGoogleLogin({
    onSuccess: (response) => {
      fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: {
          Authorization: `Bearer ${response.access_token}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setEmail(data.email); 
        })
        .catch((error) => {
          console.error('Error fetching user info:', error);
          toast.error('Failed to fetch email. Please try again.', {
            position: 'top-right',
            autoClose: 3000,
          });
        });
    },
    onError: (error) => {
      console.error('Google OAuth error:', error);
      toast.error('Failed to sign in with Google. Please try again.', {
        position: 'top-right',
        autoClose: 3000,
      });
    },
    scope: 'email',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);

    try {
      await fetch('/api/sendEmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
    } catch (error) {
      console.error('Error sending email:', error);
    } finally {
      toast.success('Your message has been sent successfully!', {
        position: 'top-right',
        autoClose: 3000,
      });
      e.target.reset();
      setEmail('');
      setIsSubmitting(false);
      handlePopupToggle();
    }
  };

  return (
    <>
      <div className={`contact-overlay ${showPopup ? 'show' : ''}`} onClick={handlePopupToggle}></div>

      <div className={`contact-popup ${showPopup ? 'show' : ''}`}>
        <button className="close-btn" onClick={handlePopupToggle} aria-label="Close contact form">×</button>

        <div className="popup-content">
          <div className="quote-section">
            <blockquote>
              "Innovation starts with collaboration. Together, we can shape the future of your business."
              <footer>- Tech Visionary</footer>
            </blockquote>
            <p>Turning your ideas into reality with full-stack development. Let's build something great together, from the front to the end!</p>
          </div>

          <div className="form-section">
            <h2>Contact 📲</h2>
            <form onSubmit={handleSubmit}>
              <input type="text" name="name" placeholder="Your Name" required />
              <div className="google-signin-container">
                <FcGoogle
                  size={24}
                  style={{ cursor: 'pointer', marginRight: '8px' }}
                  onClick={login} 
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  readOnly
                />
              </div>
              <textarea name="message" placeholder="Your Message" rows="4" required></textarea>
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Submit'}
              </button>
            </form>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};
const ContactWithGoogleOAuth = (props) => (
  <GoogleOAuthProvider clientId="56195631848-4ig4ptiia0es5l8291q1kb1v9l6n8jgj.apps.googleusercontent.com">
    <Contact {...props} />
  </GoogleOAuthProvider>
);

export default ContactWithGoogleOAuth;